// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TC_TheComp__AVmlh"};